import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";
import useZustandStore from "@src/helpers/zustand";

export const KEY = "/api/pep/types";

interface PepTypes {
  type: string;
  description: string;
  displayText: string;
  defaultChecked: boolean;
}

const apiCall = async (language: LanTypes, apiKey: string) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<PepTypes[]>(KEY, {
    headers: {
      langcode: languageCode,
      "x-api-key": apiKey,
    },
  });
  return response.data;
};

export const usePepTypes = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { data: globalState } = useZustandStore((state) => state);

  return useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: () => apiCall(i18n.language as LanTypes, globalState.apiKey),
    onError(error: any) {
      const response = error?.response;
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
